<template>
  <v-navigation-drawer right id="drawer" permanent absolute temporary width="300">
    <div style="position: fixed; top: 0; width: 100%; background-color: white; z-index: 1">
      <v-list-item>
        <v-list-item-title>
          <h3 style="margin-left: 50px">Theme</h3>
        </v-list-item-title>
        <v-list-item-action>
          <v-btn icon>
            <v-icon v-on:click="toggleSettings" color="grey lighten-1">{{mdiClose}}</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>
    </div>

    <div>
      <v-list dense>
        <v-list-item-group v-model="selectedStyle" color="primary">
          <v-list-item style="background-color: white" v-on:click="setModeAvatarStyle(item)" v-for="(item, index) in this.$store.state.avatarStyles" :key="index">
            <v-list-item-avatar size=35 color="#D3D3D3">
              <v-img :src="`https://api.dicebear.com/5.x/${item}/svg?seed=test`"></v-img>
            </v-list-item-avatar>
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider></v-divider>
    </div>

    <div style="margin-top: 20px">
      <h4 style="color: black">Avatar background</h4>
      
      <v-color-picker
        v-model="avatarBackgoundColor"
        v-on:update:color="changeColor"
        hide-mode-switch
        hide-canvas
        show-swatches
        hide-sliders
        mode="hexa"
        dot-size="25"
      ></v-color-picker>
    </div>
    
  </v-navigation-drawer>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
  name: 'settings',
  data () {
    return {
      mdiClose, 
      selectedStyle: 2,
      avatarBackgoundColor: this.$store.state.avatarBackground
    }
  },
  props: {
    messages: Array,
    userId: String
  },
  methods: {
    setModeAvatarStyle: function (style) {
      this.$socket.emit('style', { tableId: this.$router.currentRoute.params.tableId, avatarStyle: style })
    },
    toggleSettings: function () {
      this.$store.commit('toggleSettings')
    },
    changeColor(value) {
      this.$socket.emit("avatarBackground", { tableId: this.$router.currentRoute.params.tableId, avatarStyle: value.hex })
    }
  }
}
</script>
